/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ResourceType } from '../models/ResourceType';

export class ResourceTypeFilters {
  /**
  * Matches if any value in this list equals `resourceType`.
  */
  '_in'?: Array<ResourceType>;
  /**
  * Matches if no value in this list equals `resourceType`.
  */
  'notIn'?: Array<ResourceType>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_in",
      "baseName": "in",
      "type": "Array<ResourceType>",
      "format": ""
    },
    {
      "name": "notIn",
      "baseName": "notIn",
      "type": "Array<ResourceType>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ResourceTypeFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

